const MODAL_SHOW = 'modal/MODAL_SHOW';
const MODAL_HIDE = 'modal/MODAL_HIDE';

export default {
  MODAL_SHOW,
  MODAL_HIDE,
};
